<style scoped>
  .biaoji{width: 20px;height: 22px;display: inline-block;vertical-align: top;margin-top: 19px;margin-left: 24px;margin-right: 8px;}
  .note{font-size: 14px;color: #464c5b;display: inline-block;}
  .zengjia{width: 16px;height: 16px;vertical-align: top;margin-top: 22px;margin-right: 6px;}
  .addto{color: #00a2e9;font-size: 14px;display: inline-block;}
  .note-paper{background-color:#fcf4dd;cursor:pointer;height:110px;margin:15px;border-radius:5px;position:relative;overflow: hidden}
  .note-paper:hover .note-paper-del{bottom:0}
</style>

<template>
  <div class="note">
    <Modal
        v-model="notePanel.state"
        title="编写便签"
        @on-ok="notePanel.id?editNote():saveNote()"
        @on-cancel="notePanel = {state:false,content:'',title:'',id:'',}"
        ok-text="保存"
    >
      <Row>
        <Col span="24"><Input :autosize="{minRows:6,maxRows:18}" type="textarea" v-model="notePanel.content"></Input></Col>
      </Row>
    </Modal>
    <!--biaoji.png-->
    <Row style="width: 380px;height: 344px;background-color: white;">
      <Col span="24" style="height: 60px;border-bottom:1px solid #d7dde4;line-height: 60px;">
        <Col span="19">
          <img class="biaoji" src="/img/home/biaoji.png"/>
          <p class="note">便签</p>
        </Col>
        <Col span="5">
          <div @click="notePanel.id='';notePanel.content='';notePanel.state = true" style="cursor: pointer">
            <img class="zengjia" src="/img/home/zengjia.png"/>
            <p class="addto">添加</p>
          </div>
        </Col>
      </Col>
      <!--kong.png-->
      <Col span="24" style="height: 284px;overflow: auto;">
        <div style="text-align: center;margin-top: 89px;" v-if="list.length<1">
          <img src="/img/home/kong.png">
          <p style="font-size: 14px;color: #c7cdd4;">你还没有建立便签</p>
        </div>
        <Col span="8" v-for="(item,index) in list">
          <div class="note-paper">
            <div style="font-size:10px;color:white;width:100%;background-color:#00a2e9;text-align:center;height:18px" @click="deleteNote(item.id)">
              {{item.updateDate}}<Icon title="删除" @click="deleteNote(item.id)" style="float: right;line-height:18px;font-size:15px;margin-right:5px;" type="md-trash" />
            </div>

            <p title="预览/修改" @click="notePanel.content=item.content;notePanel.id=item.id;notePanel.state = true" style="height:102px;font-size:10px;overflow: hidden;margin:0px 5px" v-html="item.content.replace(/\n/g,'<br/>')"></p>
            <!--<div class="note-paper-del" @click="deleteNote(item.id)">-->
              <!--<Icon type="md-trash" />-->
              <!--删除-->
            <!--</div>-->
          </div>
        </Col>
      </Col>

    </Row>
  </div>
</template>

<script>
  export default {
    name: "note",
    data:function () {
      return{
        notePanel:{
          state:false,
          content:'',
          id:'',
        },
        list:[],
      }
    },
    mounted:function(){
      this.getNoteList()
    },
    methods:{
      getNoteList:function(){
        var _this = this
        _this.list = []
        _this.send({
          headers:'NO/ShowNote ',
          warningTips:false,
          success:function (res) {
            for(var index in res.list){
              _this.list.push({
                createDate:res.list[index].NoteCreatedTime,
                updateDate:res.list[index].NoteUpdateTime,
                content:res.list[index].NoteContent,
                id:res.list[index].NoteId,
              })
            }
          }
        })
      },
      deleteNote:function(id){
        var _this = this
        _this.send({
          headers:'NO/DelNote',
          confirm:true,
          data:{
            NoteId:id,
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！'
            })
            _this.getNoteList()
          }
        })
      },
      editNote:function () {
        var _this = this
        _this.send({
          headers:'NO/EditNote',
          data:{
            NoteContent:_this.notePanel.content,
            NoteId:_this.notePanel.id
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            _this.getNoteList()
          }
        })
      },
      saveNote:function () {
        var _this = this
        _this.send({
          headers:'NO/AddNote',
          data:{
            NoteContent:_this.notePanel.content,
          },
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            _this.getNoteList()
          }
        })
      }
    },
  }
</script>